var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { utilTime } from "../../utils/utilTime";
import { TypeActionShop } from "./actionShop";
var initial = {
    catalog: {
        packages: [],
        providers: [],
    },
    characteristics: {
        nextOffeBody: [],
        nextOfferDuration: Number.MAX_VALUE,
        offerBody: [],
        offerDuration: Number.MAX_VALUE,
        offerHead: [],
    },
    selectedOfferInfo: {
        offer: undefined,
        page: 0,
    },
    shiftLevel: {
        remainingSeconds: Number.MAX_VALUE,
        shiftLevel: 0,
    },
};
export var reducerShop = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionShop.CharacteristicsReceived:
            return __assign({}, state, { characteristics: __assign({}, action.characteristics, { offerDuration: utilTime.remainingTimeToTimestamp(action.characteristics.offerDuration), offerHead: (action.characteristics.offerHead || []).map(function (offer) { return (__assign({}, offer, { duration: utilTime.remainingTimeToTimestamp(offer.duration) })); }) }) });
        case TypeActionShop.CatalogReceived:
            return __assign({}, state, { catalog: action.catalog });
        case TypeActionShop.ShiftLevelReceived:
            return __assign({}, state, { shiftLevel: __assign({}, action.shiftLevel, { remainingSeconds: utilTime.remainingTimeToTimestamp(action.shiftLevel.remainingSeconds) }) });
        case TypeActionShop.UpdateShiftLevel:
            return __assign({}, state, { shiftLevel: __assign({}, state.shiftLevel, { remainingSeconds: utilTime.remainingTimeToTimestamp(10) }) });
        case TypeActionShop.RequestUpdate:
            return __assign({}, state, { characteristics: __assign({}, action.characteristics, { offerDuration: utilTime.remainingTimeToTimestamp(10), offerHead: (state.characteristics.offerHead || []).map(function (offer) { return (__assign({}, offer, { duration: utilTime.remainingTimeToTimestamp(10) })); }) }) });
        case TypeActionShop.SelectOffer:
            return __assign({}, state, { selectedOfferInfo: action.selectedOfferInfo || initial.selectedOfferInfo });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/reducerShop.ts
// module id = 2976
// module chunks = 3